import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconKeyboardDoubleArrowDownSvg } from "./IconKeyboardDoubleArrowDownSvg.mjs";
const IconKeyboardDoubleArrowDown = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconKeyboardDoubleArrowDownSvg, ...iconProps });
};
export {
  IconKeyboardDoubleArrowDown
};
